import SelectLoginPage from "./SelectLoginPage";

export default SelectLoginPage;
